let modishMinsideUrl = "https://minside.modish.no";
const errorContainer = document.getElementById("modish-error-container");

/*************************************************
  Check if registration has been successful 
  and shown success message
*************************************************/
const myUrl = new URL(window.location.toLocaleString());
const modishInfoBox = document.getElementsByClassName(
  "modish-registration-success"
);
if (modishInfoBox.length > 0) {
  if (myUrl.searchParams.has("registered")) {
    modishInfoBox[0].classList.add("show");
  } else if (myUrl.searchParams.has("er_medlem")) {
    modishInfoBox[0].innerHTML =
      "<h2>Du er allerede medlem i Friends of Oak</h2>";
    modishInfoBox[0].classList.add("show");
  }
}
/* ------------------ END --------------------------*/

/*************************************************
  Vipps/Check mobile number form
*************************************************/

const continueWithMobileBtn = document.getElementById(
  "modish-continue-with-mobile-btn"
);
const continueWithMobileContainer = document.getElementById(
  "modish-continue-with-mobile-container"
);
if (continueWithMobileBtn) {
  continueWithMobileBtn.addEventListener("click", function () {
    continueWithMobileContainer.classList.add("show");
    continueWithMobileBtn.classList.add("hide");
    document.getElementById("msisdn").focus();
  });

  const checkMsisdnForm = document.getElementById("modish-check-msisdn-form");
  checkMsisdnForm.addEventListener("submit", function (e) {
    e.preventDefault();
    errorContainer.innerHTML = "";
    errorContainer.style.display = "none";
    checkIfMember(this, function (response, status) {
      if (status != 200) {
        for (var error in response.errors) {
          errorContainer.innerHTML +=
            "<p>" + response.errors[error] + "</p>";
        }
        errorContainer.style.display = "block";
      } else {
        if (!response.is_member) {
          location.href =
            "/pages/friends-of-oak-register?msisdn=" + response.msisdn;
        } else {
          location.href = "/?er_medlem=1";
        }
      }
    });
    return false;
  });
}
/* ------------------ END --------------------------*/

/*************************************************
  Registration form
*************************************************/
const modishRegistrationFrom = document.getElementById("modish-member-form");
if (modishRegistrationFrom) {
  if (!myUrl.searchParams.has("msisdn")) {
    location.href='/pages/friends-of-oak';
  }
  modishRegistrationFrom.addEventListener("submit", function (e) {
    e.preventDefault();
    errorContainer.innerHTML = "";
    errorContainer.style.display = "none";
    var xhttp = new XMLHttpRequest();

    xhttp.open("POST", modishMinsideUrl + "/api/shopify/register", true);
    xhttp.setRequestHeader("Accept", "application/json");
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4) {
        let response = JSON.parse(this.responseText);
        if (this.status == 200) {
          location.href = "/?registered=1";
        } else if (response.errors) {
          for (var error in response.errors) {
            errorContainer.innerHTML +=
              "<p>" + response.errors[error][0] + "</p>";
          }
          errorContainer.style.display = "block";
        }
      }
    };
    xhttp.send(new FormData(modishRegistrationFrom));
  });
}

/* ------------------ END --------------------------*/

/*************************************************
  Complete Vipps registration form
*************************************************/

const completeForm = document.getElementById("modish-complete-registration");
if (completeForm) {
  completeForm.addEventListener("submit", function (e) {
    e.preventDefault();
    var xhttp = new XMLHttpRequest();
    xhttp.open("POST", modishMinsideUrl + "/api/shopify/vipps/complete", true);
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        let response = JSON.parse(this.responseText);
        if (response.member) {
          location.href = "/?registered=1";
        } else if (response.error) {
          alert(response.error);
        } else {
          alert("Det skjedde en uventet feil");
        }
      }
    };
    xhttp.send(new FormData(completeForm));
  });
}

/* ----------- END - Complete Vipps... ----------------*/

function checkIfMember(form, callback) {
  var xhttp = new XMLHttpRequest();
  xhttp.open("POST", modishMinsideUrl + "/api/shopify/check_member", true);
  xhttp.onreadystatechange = function () {
    if (this.readyState == 4) {
      let response = JSON.parse(this.responseText);
      callback(response, this.status);
    }
  };
  xhttp.send(new FormData(form));
}

function sendRequest(formData, callback) {
  var xhttp = new XMLHttpRequest();
  xhttp.open("POST", "https://api.dev.modish.no/shopify/modish/validate", true);
  xhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      let response = JSON.parse(this.responseText);
      callback(response);
    }
  };
  xhttp.send(formData);
}

function getQueryStringParameters() {
  var parameters = {},
    hash;
  var q = document.URL.split("?")[1];
  if (q != undefined) {
    q = q.split("&");
    for (var i = 0; i < q.length; i++) {
      hash = q[i].split("=");
      parameters[hash[0]] = hash[1];
    }
  }
  return parameters;
}

(function () {
  const inputs = document.getElementsByClassName("autocomplete");
  let params = getQueryStringParameters();
  for (let i = 0; i < inputs.length; i++) {
    let el = inputs[i];
    if (el.value == "" && params[el.dataset.key] !== undefined) {
      el.value = decodeURIComponent(params[el.dataset.key]);
    }
  }
})();
/* ------------------ END --------------------------*/
